module.exports = __webpack_public_path__ + "static/media/sketch-fat-boy.85720cb3.png";